import * as types from '../../actions/types'
import socket from '../../helpers/socket'

export function contactsGet() {
    return {
        type: types.CONTACTS_GET,
        contacts: [
            { contactId: 10, contactName:'Donald Trump', contactTime: '', contactOnline: true },
            { contactId: 22, contactName:'Johann Sebastian Bach', contactTime: '1m', contactOnline: false },
            { contactId: 11, contactName:'Carl Maria von Weber', contactTime: '2m', contactOnline: false },
            { contactId: 17, contactName:'Karen Jan', contactTime: '2.5m', contactOnline: false },
            { contactId: 25, contactName:'Andrew Coxshall', contactTime: '4m', contactOnline: false },
            { contactId: 26, contactName:'Cool Guy1', contactTime: '7m', contactOnline: false },
            { contactId: 27, contactName:'Cool Guy2', contactTime: '8m', contactOnline: false },
            { contactId: 28, contactName:'Cool Guy3', contactTime: '9m', contactOnline: false },
            { contactId: 29, contactName:'Cool Guy4', contactTime: '10m', contactOnline: false },
            { contactId: 41, contactName:'Cool Guy5', contactTime: '14m', contactOnline: false },
            { contactId: 8, contactName:'Cool Guy6', contactTime: '17m', contactOnline: false }
        ]
    }
}

export function contactSetMyId(contactId) {
    socket.emit('setContactId', contactId)
    return {
        type: types.CONTACT_SET_MY_ID,
        payload: true
    }
}

export function contactWindowMaximize() {
    return {
        type: types.CONTACT_WINDOW_MAXIMIZE,
        payload: 0
    }
}

export function contactWindowMinimize() {
    return {
        type: types.CONTACT_WINDOW_MINIMIZE,
        payload: 1
    }
}

export function contactModalBlink(contactId) {
    return {
        type: types.CONTACT_MODAL_BLINK,
        payload: contactId
    }
}

export function contactModalOpen(contactId) {
    return {
        type: types.CONTACT_MODAL_OPEN,
        payload: contactId
    }
}

export function contactModalClose(contactId) {
    return {
        type: types.CONTACT_MODAL_CLOSE,
        payload: contactId
    }
}

export function contactModalHide(contactId) {
    return {
        type: types.CONTACT_MODAL_HIDE,
        payload: contactId
    }
}

export function contactModalUnhide(contactId) {
    return {
        type: types.CONTACT_MODAL_UNHIDE,
        payload: contactId
    }
}

export function contactSwitchToHidden(contactId) {
    return {
        type: types.CONTACT_SWITCH_TO_HIDDEN,
        payload: contactId
    }
}




// WEBPACK FOOTER //
// ./src/actions/chat/contactActions.js